import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { LocalizationProvider } from './context/localization';
import {CookieSettingsProvider} from "./context/cookieSettingsContext"; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <LocalizationProvider>
            <CookieSettingsProvider>
            <App />
                </CookieSettingsProvider>
        </LocalizationProvider>
    </React.StrictMode>
);
